import styled from "styled-components";

export const MainContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 0;
`;
